import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { environment as ENV } from '../../environments/environment';
import { inject, Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take, switchMap, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InternalGuard {
  constructor(
    private jwtHelper: JwtHelperService,
    private auth: AuthService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    let id_token = route.fragment?.match(/^id_token=([\w_.\-]+)?&/i) || ['', localStorage.getItem('id_token')];  //Grab token from URL or session
    if (!id_token || id_token.length != 2 || !id_token[1] || this.jwtHelper.isTokenExpired(id_token[1])) {
      sessionStorage.clear();
      window.location.href = ENV.roleLevelSecurity.signin;
      return of(false);
    } else {
      let idToken = id_token[1];
      localStorage.setItem('id_token', idToken);
      sessionStorage.setItem('userDetails', JSON.stringify({ internalUser: true }));
      sessionStorage.setItem('permissions', JSON.stringify([]));
      let email = this.jwtHelper.decodeToken(idToken).unique_name;
      return this.checkAuth0Token(email);
    }
  }

  checkAuth0Token(email: string) {
    return this.auth.isLoading$.pipe(
      filter(loading => !loading),
      take(1),
      switchMap(() => this.auth.idTokenClaims$),
      take(1),
      map(response => {
        if (!response) {
          this.initiatePasswordlessAuth(email);
          return false;
        }
        return !!(response.__raw && response.email);
      })
    );
  }

  initiatePasswordlessAuth(email: string) {
    this.auth.loginWithRedirect({
      authorizationParams: {
        connection: 'email',
        login_hint: email,
        redirect_uri: `${ENV.baseUrl.web}callback`,
        'ext-connect': 'email', //additional param to indicate template to hide "sign up" and "login" text
        'ext-type': 'hint'
      },
      appState: { target: '/internal' }
    });
  }

}